import {
  AUTO_WITHDRAW_FREQUENCY,
  FAQ_TXN_STATE,
  ICON_MAPS,
  TIMELINE_STATE,
  TIMELINE_TYPE,
  TRANSACTION_STATE,
  TRANSACTION_TABLE_ENTITY_TYPE,
  TRANSACTION_UI_STATUS,
  VIEW_ENTITY_TYPE,
  WITHDRAW_INITIATED_BY,
} from "../../services/RecentActivity/recentTransactions/recentTransaction.constants";
import { CHATBOT_SOURCE } from "../../utils/constants";

export const getTransactionTableEntityType = sponsorView => {
  console.log(sponsorView, "sponsorview");
  switch (sponsorView?.type) {
    case VIEW_ENTITY_TYPE.SPONSOR_CREDIT_TRANSACTION:
    case VIEW_ENTITY_TYPE.SENT_PAYMENT:
      return TRANSACTION_TABLE_ENTITY_TYPE.DEPOSIT;
    case VIEW_ENTITY_TYPE.ONBOARDING_PLAN_TRANSACTION:
      return TRANSACTION_TABLE_ENTITY_TYPE.ACCOUNT_OPENING_FEE;
    case VIEW_ENTITY_TYPE.SPONSOR_DEBIT_TRANSACTION:
      if (
        sponsorView?.data?.initiatedBy ===
        WITHDRAW_INITIATED_BY.USER
      )
        return TRANSACTION_TABLE_ENTITY_TYPE.WITHDRAWAL;

      if (
        sponsorView?.data?.initiatedBy ===
        WITHDRAW_INITIATED_BY.PROVIDER
      ) {
        if (
          sponsorView?.data?.autoWithdrawalFrequency ===
          AUTO_WITHDRAW_FREQUENCY.MONTHLY
        )
          return TRANSACTION_TABLE_ENTITY_TYPE.MONTHLY_AUTO_WITHDRAWAL;

        if (
          sponsorView?.data?.autoWithdrawalFrequency ===
          AUTO_WITHDRAW_FREQUENCY.QUARTERLY
        )
          return TRANSACTION_TABLE_ENTITY_TYPE.QUARTERLY_AUTO_WITHDRAWAL;
      }
      return null;
    default:
      return null;
  }
};

export const getTransactionIcons = sponsorView => {
  switch (sponsorView?.type) {
    case VIEW_ENTITY_TYPE.SPONSOR_CREDIT_TRANSACTION:
    case VIEW_ENTITY_TYPE.SENT_PAYMENT:
      return ICON_MAPS.DEPOSIT_ICON;
    case VIEW_ENTITY_TYPE.ONBOARDING_PLAN_TRANSACTION:
      return ICON_MAPS.ACC_OPENING_ICON;
    case VIEW_ENTITY_TYPE.SPONSOR_DEBIT_TRANSACTION:
      return ICON_MAPS.WITHDRAW_ICON;
    default:
      return "";
  }
};

export const getTransactionType = sponsorView => {
  switch (sponsorView?.type) {
    case VIEW_ENTITY_TYPE.SPONSOR_CREDIT_TRANSACTION:
    case VIEW_ENTITY_TYPE.SENT_PAYMENT:
    case VIEW_ENTITY_TYPE.ONBOARDING_PLAN_TRANSACTION:
      return CHATBOT_SOURCE.FUNDS_IN;
    case VIEW_ENTITY_TYPE.SPONSOR_DEBIT_TRANSACTION:
      return CHATBOT_SOURCE.FUNDS_OUT;
    default:
      return CHATBOT_SOURCE.FUNDS_IN;
  }
};

export const getWithdrawTransactionStatus = sponsorView => {
  const timelines = sponsorView?.data?.timelines;

  const state = sponsorView?.state;

  if (
    state === TRANSACTION_STATE.ERRORED &&
    timelines?.length > 0
  ) {
    const { timelineType, timelineState } = timelines[
      timelines.length - 1
    ];
    if (
      timelineType === TIMELINE_TYPE.CANCELLED &&
      timelineState === TIMELINE_STATE.ERRORED
    ) {
      return TRANSACTION_UI_STATUS.CANCELLED;
    }
    if (
      timelineType === TIMELINE_TYPE.ACCEPTED &&
      timelineState === TIMELINE_STATE.ERRORED
    ) {
      return TRANSACTION_UI_STATUS.REJECTED;
    }
  }
  if (
    state === TRANSACTION_STATE.PENDING &&
    timelines?.length > 0
  ) {
    const accepted =
      (timelines || []).filter(
        timeline =>
          timeline.timelineType ===
            TIMELINE_TYPE.ACCEPTED &&
          timeline.timelineState ===
            TIMELINE_STATE.COMPLETED
      ).length > 0;
    if (accepted) return TRANSACTION_UI_STATUS.ACCEPTED;
  }
  if (state === TRANSACTION_STATE.ERRORED) {
    return TRANSACTION_UI_STATUS.ERRORED;
  }
  return TRANSACTION_UI_STATUS[state];
};

export const getTxnState = state => {
  switch (state) {
    case TRANSACTION_STATE.COMPLETED:
      return FAQ_TXN_STATE.SUCCESS;
    case TRANSACTION_STATE.ERRORED:
      return FAQ_TXN_STATE.FAILED;
    case TRANSACTION_STATE.PENDING:
      return FAQ_TXN_STATE.PENDING;
  }
};
